import React, { Component } from 'react'
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

class Blank extends Component {
    render() {
        return (
            <React.Fragment>

            </React.Fragment>
        )
    }
}

/**
* ================================================================
*               Props Validation & Import/Export
* ================================================================
*/
const mapStateToProps = (store) => {
    return {
        dispatch: store.dispatch
    }
}
export default connect(
    mapStateToProps
)(Blank)

Blank.propTypes = {
    history: PropTypes.object,
    dispatch: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/components/layouts/BlankLayout/BlankLayout.js